<script setup lang="ts">
import { type HTMLAttributes, computed } from "vue";
import {
    SelectIcon,
    SelectTrigger,
    type SelectTriggerProps,
    useForwardProps,
} from "radix-vue";
import { ChevronDown } from "lucide-vue-next";
import { cn } from "@/lib/utils";

const props = defineProps<
    SelectTriggerProps & { class?: HTMLAttributes["class"] }
>();

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <SelectTrigger
        v-bind="forwardedProps"
        :class="
            cn(
                'dark:bg-iron-950 dark:ring-offset-iron-950 h-10 rounded-md border-iron-300 bg-white px-3 py-2 text-sm shadow-xs ring-offset-white placeholder:text-iron-500 focus:border-z-primary-300 focus:ring-z-primary-100 dark:border-iron-800 dark:placeholder:text-iron-400 dark:focus:ring-iron-300 flex w-full items-center justify-between border focus:ring-2 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1',
                props.class,
            )
        "
    >
        <slot />
        <SelectIcon as-child>
            <ChevronDown class="h-4 w-4 opacity-50" />
        </SelectIcon>
    </SelectTrigger>
</template>
